import { useCurrentWorkspace } from '@/context/current-workspace';
import { Link, Text } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';
import type { BackfillComputed } from '@/features/tasks';
import { generateBackfillRoute } from '@/features/tasks';
import { capitalize } from 'lodash-es';

export interface TaskObjectProps {
  backfill: BackfillComputed;
}

export function TaskObject({ backfill }: TaskObjectProps) {
  const workspace = useCurrentWorkspace();
  const workspaceId = workspace?.id;

  const hasObjectName = !isEmptyString(backfill.object_name);

  const displayText = hasObjectName ? backfill.object_name : backfill.object_id;

  const routeUrl =
    backfill.object_deleted !== true && workspaceId != null && workspaceId !== 0
      ? generateBackfillRoute(backfill, workspaceId)
      : null;

  if (!isEmptyString(backfill.info.description)) {
    return <Text color="subtle">{backfill.info.description}</Text>;
  }

  const objectTypeLabel =
    backfill.info.objectType === 'sql-import' ? backfill.info.label : capitalize(backfill.info.objectType);

  if (!isEmptyString(routeUrl)) {
    return (
      <>
        <Text color="subtle">{objectTypeLabel}</Text>{' '}
        <Text>
          <Link href={routeUrl} variant="primary" isUnderlined={false} icon="chevron-right" iconPosition="trailing">
            {displayText}
          </Link>
        </Text>
      </>
    );
  }

  return (
    <Text>
      {displayText}
      {backfill.object_deleted === true ? <Text color="subtle"> (deleted)</Text> : null}
    </Text>
  );
}
